export function addQueryParamToUrls(url: string, key: string, value: string) {
  const config = useRuntimeConfig();

  const parsedUrl = new URL(url, config.public.seo.siteUrl);
  parsedUrl.searchParams.set(key, value);
  return parsedUrl.toString();
}
